import React, { Component } from 'react';
import { reduxForm, Field, FieldArray, change } from 'redux-form';
import { renderDateField, renderAutoCompleteSingleSelect, isValidNameWithSpace, renderTextField } from '../../../../../../components/reduxFields'
import { connect } from 'react-redux';
import classNames from 'classnames';
import { CommonButton } from '../../../../../../components/buttons'
import { getPatientBehaviorsReductionByPatientId, getTargetsAndProgramsData, SaveDefaultPhaseChangeline, getDefaultPhaseChangelines, getDefaultPhaseChangelinesSettings } from './actions/DefaultPhaseChangeLinesActions';
import _ from 'lodash';
import moment from 'moment';
import { clearFieldErrorArray } from '../../../../../../modules/AppConfig/actions';

const validate = (values) => {
    const errors = {};
    if (values.patientPhaseChangeline && values.patientPhaseChangeline.length) {     
      const patientPhaseChangelineArrayErrors = [];      
      values.patientPhaseChangeline.forEach((Obj, index) => {
        const phaseChangelineErrors = {};        
        if (Obj && !Obj.lineDate) {      
            phaseChangelineErrors.lineDate = 'Please enter line date.';
            patientPhaseChangelineArrayErrors[index] = phaseChangelineErrors;
        }
        if (Obj && !Obj.lineType) {
          phaseChangelineErrors.lineType = 'Please select line type.';
          patientPhaseChangelineArrayErrors[index] = phaseChangelineErrors;
        }
        if (Obj && !Obj.lineLabel) {
          phaseChangelineErrors.lineLabel = 'Please select line label.';
          patientPhaseChangelineArrayErrors[index] = phaseChangelineErrors;
        }
        
        return phaseChangelineErrors;
      });
      if (patientPhaseChangelineArrayErrors.length) {
        errors.patientPhaseChangeline = patientPhaseChangelineArrayErrors;
      }
    }

    if (!values.baselinesLineType) {
      errors.baselinesLineType = 'Please select baseline type.';
    }

    if (!values.masteredLineType) {
      errors.masteredLineType = 'Please select mastered line type.';
    }
    return errors;
  };
  
class DefaultPhaseChangeLines extends Component {
    constructor(props) {
        super(props);
        this.state = {       
            patientId: props.patientId,
            lineDate: [],     
            dashStyle: [
              { id: 1, value: "Solid" },
              { id: 2, value: "ShortDash" },
              { id: 3, value: "ShortDot" },
              { id: 4, value: "Dot" },          
              { id: 5, value: "Dash" },       
              { id: 6, value: "LongDash" },          
              ]
          };
        this.handleNewRequest = this.handleNewRequest.bind(this);
        this.renderPhaseChangelineTemplate = this.renderPhaseChangelineTemplate.bind(this);
    }

    componentWillMount() {       
        this.props.getPatientBehaviorsReductionByPatientId(this.state.patientId);
        this.props.getTargetsAndProgramsData(this.state.patientId);

        if (this.state.patientId) {
          this.props.getDefaultPhaseChangelines(this.state.patientId);
          this.props.getDefaultPhaseChangelinesSettings(this.state.patientId);
        }
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.save_DefaultPhaseChangeline && nextProps.save_DefaultPhaseChangeline !== this.props.save_DefaultPhaseChangeline) {
        this.props.getDefaultPhaseChangelines(this.state.patientId);
        this.props.getDefaultPhaseChangelinesSettings(this.state.patientId);

       }

        if (nextProps.defaultPhaseChangelinesData && nextProps.defaultPhaseChangelinesData !== this.props.defaultPhaseChangelinesData) {

          let lineDate1 = this.state.lineDate;
          (nextProps.defaultPhaseChangelinesData || []).forEach((obj, index) => {
              _.update(lineDate1, `[${index}]`, function (n) {                  
                  return moment(obj.lineDate).format('MM-DD-YYYY');
              });                           
              this.props.dispatch(change('PatientDefaultPhaseChangeLinesForm', `patientPhaseChangeline[${index}].lineDate`, moment(obj.lineDate).format('MM-DD-YYYY') || null));
          });
          
          this.setState({ lineDate: lineDate1 });

      }
    }

    handleNewRequest(input, selectedRecord) {
        input.onChange(selectedRecord.value);
    }

    onDateChange = (input, value, index) => {
      
        input.onChange(moment(value).format());
        let lineDate1 = this.state.lineDate;
    
        _.update(lineDate1, `[${index}]`, function (n) {
          return moment(value).format('MM-DD-YYYY');
      });
     
        this.setState({ lineDate: lineDate1 }, ()=>{          
          //this.props.dispatch(change('PatientDefaultPhaseChangeLinesForm', `patientPhaseChangeline[${index}].lineDate`,   moment(lineDate1[index]).format('MM-DD-YYYY')));          
           document.getElementsByName(`patientPhaseChangeline[${index}].lineLabel`)[0].focus();           
        });
    }

   

    onSubmitHandler(formData) {
        // console.log(formData);
        if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
          return null;
        }
    
        this.props.clearFieldErrorArray();
    
        // ---------------Start Save to patientPhaseChangeline ------------
        // console.log(formData.patientPhaseChangeline);
        let listRawDATA = [];
        if (formData.patientPhaseChangeline && formData.patientPhaseChangeline.length) { 
          formData.patientPhaseChangeline.filter((data, i) => {            
              let lineDate = moment(data.lineDate).format('YYYY-MM-DDTHH:mm:ss');
              if (lineDate && data.lineType) {
              let currentData = {
                  'id': data.id ? data.id : 0,
                  'lineLabel': data.lineLabel, 
                  'lineDate': lineDate,
                  'lineType': data.lineType,
                  'skillsAcquisitionProgramId': data.skillsAcquisitionProgramId,
                  'skillsAcquisitionTargetId': data.skillsAcquisitionTargetId,
                  'behaviorsReductionId': data.behaviorsReductionId,
                  'patientId': this.state.patientId,                
                  'createdBy': data.createdBy,
                  'createdDate': data.createdDate,                        
              };
              listRawDATA.push(currentData);        
            }                
              return listRawDATA;
          });
        }
        formData.patientPhaseChangeline = listRawDATA;
        
        if(formData.baselinesLineType) {
          let patientMasterBaseLineSettings = {            
            'lineTypeName': 'BASELINES_LINE',
            'lineType': formData.baselinesLineType,
            'patientId': this.state.patientId,                            
          };
          formData.patientMasterBaseLineSettings = patientMasterBaseLineSettings;
        }
        if(formData.masteredLineType) {
          let patientMasterMasteredSettings = {            
            'lineTypeName': 'MASTERED_LINE',
            'lineType': formData.masteredLineType,
            'patientId': this.state.patientId,                            
          };
          formData.patientMasterMasteredSettings = patientMasterMasteredSettings;
        }
        
        // ---------------End Save to patientPhaseChangeline ------------        
        this.props.SaveDefaultPhaseChangeline(formData, this.state.patientId);

        setTimeout(function() {
          this.props.getPatientBehaviorsReductionByPatientId(this.state.patientId);
          this.props.getTargetsAndProgramsData(this.state.patientId);
  
         
            this.props.getDefaultPhaseChangelines(this.state.patientId);
            this.props.getDefaultPhaseChangelinesSettings(this.state.patientId);
          
      }.bind(this),1000)
        
        
        //this.props.closeDialog();
      }

    addRow = () => { };
    removeRow = (i) => { };
  
    renderPhaseChangelineTemplate = ({ fields }) => {
      this.addRow = (e) => {
        fields.push({});
      };
  
      this.removeRow = (i, e) => {
        fields.remove(i);

        // Update the lineDate state to remove the corresponding date
        let updatedLineDate = [...this.state.lineDate];
        updatedLineDate.splice(i, 1); // Remove the date at the specified index
        this.setState({ lineDate: updatedLineDate });
      };
  
      return (
        <div>
          {fields.map((data, i) =>          
            <div className="row" key={i}>          
              <div className="col-sm-1 require">
                <Field
                  name={`patientPhaseChangeline[${i}].lineDate`}
                  placeholder="Line Date"
                  locale="en-US"
                  selected={this.state.lineDate[i] || null}
                  onDateChange={(input, selectedValue) => this.onDateChange(input, selectedValue, i)}
                  openToYearSelection={true}
                  className="ClsPatientPhaseChangeLineDateSetup"
                  component={renderDateField} />
              </div>
              <div className="col-sm-2 require">                
                <Field
                    name={`patientPhaseChangeline[${i}].lineLabel`}
                    type="text"
                    maxLength="100"
                    normalize={isValidNameWithSpace}
                    label="Line Label"
                    className="ClsPatientPhaseChangeLineSetup"
                    component={renderTextField} />
              </div>
              <div className="col-sm-1 mt-40 require ClsPatientPhaseChangeLineSetup">
                <Field
                  name={`patientPhaseChangeline[${i}].lineType`}
                  hintText="Line Type"
                  handleNewRequest={(input, selectedValue) => this.handleNewRequest(input, selectedValue)}
                  options={this.state.dashStyle}
                  className="ClsPatientPhaseChangeLineSetup"
                  component={renderAutoCompleteSingleSelect}
                />
              </div>
              <div className="col-sm-2 mt-40 ClsPatientPhaseChangeLineSetup">
                <Field
                  name={`patientPhaseChangeline[${i}].skillsAcquisitionProgramId`}
                  hintText="Program"
                  handleNewRequest={(input, selectedValue) => this.handleNewRequest(input, selectedValue)}
                  options={this.props.masterPatientPrograms}
                  className="ClsPatientPhaseChangeLineSetup"
                  component={renderAutoCompleteSingleSelect}
                />
              </div>
              <div className="col-sm-2 mt-40 ClsPatientPhaseChangeLineSetup">
                <Field
                  name={`patientPhaseChangeline[${i}].skillsAcquisitionTargetId`}
                  hintText="Target"
                  handleNewRequest={(input, selectedValue) => this.handleNewRequest(input, selectedValue)}
                  options={this.props.masterPatientTargets}
                  className="ClsPatientPhaseChangeLineSetup"
                  component={renderAutoCompleteSingleSelect}
                />
              </div>
              <div className="col-sm-2 mt-40 ClsPatientPhaseChangeLineSetup">
                <Field
                  name={`patientPhaseChangeline[${i}].behaviorsReductionId`}
                  hintText="Behavior"
                  handleNewRequest={(input, selectedValue) => this.handleNewRequest(input, selectedValue)}
                  options={this.props.masterPatientBehaviorsReductions}
                  className="ClsPatientPhaseChangeLineSetup"
                  component={renderAutoCompleteSingleSelect}
                />
              </div>

              {fields.length === i + 1 ?
                <div className="col-sm-2 mt-40">
                  {fields.length > 1 ?
                    <button className=" additemtable removeitemtable"
                      onClick={this.removeRow.bind(this, i)}
                      title="Remove Data"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                    : ''}
                  <button className="additemtable" title="Add Data" onClick={(e) => this.addRow()} type="button">
                    <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                  </button>
                </div>
                :
                <div className="col-sm-2 mt-40">
                  <button className="additemtable"
                    onClick={this.removeRow.bind(this, i)}
                    title="Remove Data"
                    type="button">
                    <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                  </button>
                </div>
  
              }
            </div>
          )}
        </div>
      );
    };

    render() {
        const { handleSubmit } = this.props;        
        const tableClass = classNames({
          'table': true,
          'table-striped': this.props.bordered,
          'table-bordered': this.props.bordered,
          'table-hover': true,
          'table-condensed': this.props.condensed,
          'customtable': true,
          'suptable': true,
        });
        return (
          <div>
              <div>
                <div className="clearfix"></div>
                <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} >
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="panel_title">
                        <h3>Add phase change lines</h3>
                        <i className="flaticon flaticon-user-with-computer-monitor-and-bar-graphs"></i>
                      </div>
    
                      <FieldArray name="patientPhaseChangeline" component={this.renderPhaseChangelineTemplate} />
    
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6">
                      <div className="panel_title">
                        <h3>Add phase change lines for Baselines Line Type</h3>
                        <i className="flaticon flaticon-user-with-computer-monitor-and-bar-graphs"></i>
                      </div>
                    </div>
                    <div className="col-sm-6 mt-30 require">
                      <Field
                      name="baselinesLineType"
                      hintText="Base Line Type"
                      handleNewRequest={(input, selectedValue) => this.handleNewRequest(input, selectedValue)}
                      options={this.state.dashStyle}
                      component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6">
                      <div className="panel_title">
                        <h3>Add phase change lines for Mastered Line Type</h3>
                        <i className="flaticon flaticon-user-with-computer-monitor-and-bar-graphs"></i>
                      </div>
                    </div>
                    <div className="col-sm-6 mt-30 require">
                      <Field
                      name="masteredLineType"
                      hintText="Mastered Line Type"
                      handleNewRequest={(input, selectedValue) => this.handleNewRequest(input, selectedValue)}
                      options={this.state.dashStyle}
                      component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                  </div>
                 
    
                  {this.props.addPermission ?
                        <div className="row">
                            <div className="col-sm-12 pt20 btn_rt">
                                {this.props.loading ?
                                    <CommonButton primary={true} className="loader_btn" disabled={true} label="Saving" />
                                    : <CommonButton type="submit" primary={true} label="Save" />}
                            </div>
                        </div>
                        : null
                    }                  
                </form>
              </div>
          </div>
        );
      }
}

//const selector = formValueSelector('PatientGeneralSettingsForm');
const mapStateToProps = (state, ownProps) => {

    let patientPhaseChangeline = [], baselinesLineType = null, masteredLineType = null, defaultPhaseChangelinesData = [], defaultPhaseChangelinesSettings = [];
    let initialValueData = {
        patientPhaseChangeline: [{}],
      };

  if(state.patient_defaultPhaseChangeLines.defaultPhaseChangelines){    
    defaultPhaseChangelinesData = state.patient_defaultPhaseChangeLines.defaultPhaseChangelines.data;  
    if (defaultPhaseChangelinesData && defaultPhaseChangelinesData.length) {      
      defaultPhaseChangelinesData.filter((data, i) => {                
        patientPhaseChangeline.push({
          'id': data.id,
          'patientId': data.patientId,
          'lineLabel': data.lineLabel,
          'lineDate': data.lineDate,
          'lineType': data.lineType,
          'skillsAcquisitionProgramId': data.skillsAcquisitionProgramId,
          'skillsAcquisitionTargetId': data.skillsAcquisitionTargetId,
          'behaviorsReductionId': data.behaviorsReductionId,
          'createdBy': data.createdBy,
          'createdDate': data.createdDate,
        });
        return patientPhaseChangeline;
      });
    } else {
      patientPhaseChangeline = [{}];
    }

  }
 
  if(state.patient_defaultPhaseChangeLines && state.patient_defaultPhaseChangeLines.defaultPhaseChangelinesSettings){
    defaultPhaseChangelinesSettings = state.patient_defaultPhaseChangeLines.defaultPhaseChangelinesSettings.data;

    if (defaultPhaseChangelinesSettings && defaultPhaseChangelinesSettings.length) {      
      defaultPhaseChangelinesSettings.filter((data, i) => {                      
        if(data.lineTypeName === "BASELINES_LINE"){
            baselinesLineType = data.lineType;     
            return baselinesLineType;
          }   
      });
    } 

    if (defaultPhaseChangelinesSettings && defaultPhaseChangelinesSettings.length) {      
      defaultPhaseChangelinesSettings.filter((data, i) => {                      
        if(data.lineTypeName === "MASTERED_LINE") {
            masteredLineType = data.lineType;      
            return masteredLineType;
        } 
      });
    } 
  }

  initialValueData = {
    patientPhaseChangeline: patientPhaseChangeline,     
    baselinesLineType: baselinesLineType,     
    masteredLineType: masteredLineType, 
  };
  
    let masterPatientBehaviorsReductions = [], masterPatientPrograms = [], masterPatientTargets = [];

    if (state.patient_defaultPhaseChangeLines.targetsAndProgramsData) {
        masterPatientPrograms = state.patient_defaultPhaseChangeLines.targetsAndProgramsData.data.Programs || [];
        masterPatientTargets = state.patient_defaultPhaseChangeLines.targetsAndProgramsData.data.Targets || [];
    }

    if (state.patient_defaultPhaseChangeLines.behaviorsReductionsData) {
        masterPatientBehaviorsReductions = state.patient_defaultPhaseChangeLines.behaviorsReductionsData.data.PatientBehaviorsReduction || [];        
    }
    

    // Start For Role Permission
    // let userActionPermission = [];
    // if (state.login.userPermission) {
    //     let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === "CLIENT");
    //     let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === "CLIENT_DATACOLLECTION_SETUP" && obj.moduleId === userModulePermission[0].moduleId);
    //     userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
    // }

    // let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

    // let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_ADD_GENERAL_SETTINGS")[0].permission : false;
       let addPermission =true;
    // End For Role Permission

    return {
        initialValues: initialValueData,
        masterPatientBehaviorsReductions: masterPatientBehaviorsReductions,    
        masterPatientPrograms: masterPatientPrograms,
        masterPatientTargets: masterPatientTargets,
        save_DefaultPhaseChangeline: state.patient_defaultPhaseChangeLines.save_DefaultPhaseChangeline,
        loading: state.patient_defaultPhaseChangeLines.loading,
        addPermission: addPermission, // For Role Permission
        defaultPhaseChangelinesData: defaultPhaseChangelinesData,

    };
};

DefaultPhaseChangeLines = reduxForm({
    form: 'PatientDefaultPhaseChangeLinesForm', // a unique identifier for this form
    validate,
    enableReinitialize: true,
})(DefaultPhaseChangeLines);


export default connect(mapStateToProps, { getPatientBehaviorsReductionByPatientId, SaveDefaultPhaseChangeline, getDefaultPhaseChangelines, getDefaultPhaseChangelinesSettings, getTargetsAndProgramsData, clearFieldErrorArray })(DefaultPhaseChangeLines);


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SetUp/defaultPhaseChangeLines/index.js